import { render, staticRenderFns } from "./show.vue?vue&type=template&id=a7c99e20&lang=pug&"
import script from "./show.vue?vue&type=script&setup=true&lang=js&"
export * from "./show.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=a7c99e20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports